import { ArrowUpRight, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import { productLinks } from "../../data/products";
import { Reveal } from "../ui/Reveal";

export function StartupBand() {
  return (
    <div className="startup-band page-container">
      <p>
        Startup programs
        <span>Incubated at Qatar Science & Technology Park.</span>
      </p>
      <div
        className="startup-names"
        aria-label="Stratify participates in these startup programs"
      >
        <span className="startup-qstp">
          QSTP
          <span>
            Qatar Science &<br />
            Technology Park
          </span>
        </span>
        <span>Microsoft</span>
        <span className="startup-github">GitHub</span>
        <span className="startup-cloudflare">Cloudflare</span>
        <span>DigitalOcean</span>
      </div>
      <small>Incubation & startup programs</small>
    </div>
  );
}

const principles = [
  {
    label: "Customers",
    title: "Compare services before you book.",
    body: "Review professional profiles and service packages. Message the professional to discuss the work, then book through Stratify Services.",
    href: "/services",
    action: "View service categories",
    internal: true,
  },
  {
    label: "Businesses",
    title: "Manage bookings and team access.",
    body: "Use Stratify Business to manage service listings, customer bookings, and event tickets. Invite team members and assign their roles.",
    href: productLinks.business,
    action: "Open Stratify Business",
  },
  {
    label: "Food shoppers",
    title: "Buy surplus food for local pickup.",
    body: "Find surplus meals, pastries, and groceries on Stratify Deals. Check the price and pickup window before you pay, then collect from the business.",
    href: productLinks.deals,
    action: "Browse food deals",
  },
];

export function EverydaySection() {
  return (
    <section id="about" className="everyday-section page-container">
      <Reveal className="section-intro">
        <div>
          <span className="eyebrow">About</span>
          <h2>
            What you can do{" "}
            <br />
            <span>with Stratify.</span>
          </h2>
        </div>
        <p>
          Compare services before booking, manage your business, or buy surplus
          food for collection nearby.
        </p>
      </Reveal>
      <div className="everyday-grid">
        <Reveal className="everyday-photo">
          <img
            src="/assets/landing/hero-team.webp"
            alt="People working together around a shared table"
            width="2200"
            height="1467"
            loading="lazy"
          />
        </Reveal>
        <div className="everyday-principles">
          {principles.map((item, index) => (
            <Reveal key={item.label} delay={index * 0.06}>
              <span className="eyebrow">{item.label}</span>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
              {item.internal ? (
                <Link to={item.href} className="text-link">
                  {item.action} <ArrowUpRight size={15} />
                </Link>
              ) : (
                <a href={item.href} className="text-link">
                  {item.action} <ArrowUpRight size={15} />
                </a>
              )}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

const faqs = [
  {
    question: "Which Stratify product should I use?",
    answer:
      "Use Stratify Services to book professionals and event tickets. Use Stratify Business to manage service listings, bookings, events, and team access. Use Stratify Deals to buy surplus food for local pickup.",
  },
  {
    question: "Can I use Stratify without downloading an app?",
    answer:
      "Yes. Services, Business, and Deals are available in your browser. Stratify Services also has a mobile app.",
  },
  {
    question: "Is Stratify available in my location?",
    answer:
      "Services and food deals are available in supported locations in Nigeria. Check each listing for its service area or pickup location.",
  },
  {
    question: "How do Stratify Deals work?",
    answer:
      "Choose your city and browse surplus food from local businesses. Check the price, quantity, and pickup window before you pay online. Your order shows where and when to collect it.",
  },
  {
    question: "Can I add my team to Stratify Business?",
    answer:
      "Yes. Invite team members to help manage your services or events. Each person's role determines what they can access.",
  },
  {
    question: "How can I partner with Stratify?",
    answer:
      "Email support@stratifyservice.com with a brief description of your business and the partnership you have in mind.",
  },
];

export function LandingFaq() {
  return (
    <section className="landing-faq page-container">
      <Reveal className="faq-intro">
        <span className="eyebrow">FAQ</span>
        <h2>Common questions</h2>
        <p>Contact us for help with any Stratify product.</p>
        <Link to="/contact" className="text-link">
          Contact us <ArrowUpRight size={15} />
        </Link>
      </Reveal>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <Reveal key={faq.question} delay={index * 0.04}>
            <details>
              <summary>
                {faq.question}
                <ChevronDown size={18} strokeWidth={1.75} />
              </summary>
              <p>{faq.answer}</p>
            </details>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
